import React from "react";
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import PropTypes from "prop-types";
import { FiUpload } from "react-icons/fi";

const ImageUploadBox = ({ label, file, onFileChange, onRemove, accept = "image/jpeg,image/jpg,image/png", fileInputId }) => {
  const hasFile = file !== null;
  const previewUrl = hasFile ? URL.createObjectURL(file) : null;

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      {hasFile ? (
        <div className="relative border-2 border-gray-300 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {previewUrl && (
                <img
                  src={previewUrl}
                  alt={label || "Uploaded image"}
                  className="h-20 w-auto object-contain rounded"
                />
              )}
              <div>
                <p className="text-sm font-medium text-gray-900">{file.name}</p>
                <p className="text-xs text-gray-500">
                  {(file.size / 1024 / 1024).toFixed(2)} MB
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                onRemove();
                if (fileInputId) {
                  const input = document.getElementById(fileInputId);
                  if (input) input.value = "";
                }
              }}
              className="text-red-500 hover:text-red-700 p-1"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      ) : (
        <label
          htmlFor={fileInputId}
          className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary/50 transition-colors cursor-pointer block"
        >
          <input
            id={fileInputId}
            type="file"
            accept={accept}
            onChange={onFileChange}
            className="hidden"
          />
           <FiUpload className="mx-auto h-8 w-8 text-gray-400 mb-2" />
          <p className="text-sm text-gray-600">
            Drop your image here, or click to select
          </p>
          <p className="text-xs text-gray-500 mt-1">Supports: JPG, JPEG, PNG, PDF</p>
        </label>
      )}
    </div>
  );
};

ImageUploadBox.propTypes = {
  label: PropTypes.string,
  file: PropTypes.object,
  onFileChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  accept: PropTypes.string,
  fileInputId: PropTypes.string.isRequired,
};

export default withFeatureSafe(ImageUploadBox);